export function getAppContext(loaderConfig) {
    const appContext = {};
    if (loaderConfig.configuration) {
        appContext.namespace = loaderConfig.configuration.namespace || '';
        appContext.environment = loaderConfig.configuration.environment || '';
        appContext.configVersion = loaderConfig.configuration.source && loaderConfig.configuration.source.version;
    }
    if (loaderConfig.userIdentity) {
        appContext.userIdentity = {
            userId: loaderConfig.userIdentity.userId || '',
            sessionId: loaderConfig.userIdentity.sessionId || '',
        };
    }
    return appContext;
}

export default {
    getAppContext,
};



// WEBPACK FOOTER //
// ../loader-base/src/helpers/app-context-helper.js